import { fetchOfferBasedRecommendations } from 'actions/RecommendationActions'
import { useEffect } from 'react'

import { useAppDispatch } from 'hooks/reduxHooks'
import moment from 'moment'
import { ISO_DATE_FORMAT } from 'constants/dateFormats'
import { occupancyToStr } from 'api/recommendations'

function useLoadOfferBasedLereRecommendations(offerId: string | undefined, readyToLoad: boolean, checkIn?: string, checkOut?: string, duration?: number, rooms?: App.Occupants[], model_version?: string) {
  const dispatch = useAppDispatch()

  useEffect(() => {
    if (!offerId || !readyToLoad) {
      return
    }

    let checkOutParam = checkOut
    if (!!duration && !checkOut && !!checkIn) {
      checkOutParam = moment(checkIn).add(duration, 'days').format(ISO_DATE_FORMAT)
    }

    let occupancy: string | undefined = undefined
    if (rooms) {
      occupancy = occupancyToStr(rooms)
    }
    dispatch(fetchOfferBasedRecommendations(offerId, false, checkIn, checkOutParam, occupancy, model_version))
  }, [dispatch, offerId, readyToLoad, checkIn, checkOut, duration, rooms, model_version])
}

export default useLoadOfferBasedLereRecommendations
